import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';
import MembersSidebar from '../components/MembersSidebar';

const MembersOrders = () => {
  const navigate = useNavigate();
  const [member, setMember] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [logoutLoading, setLogoutLoading] = useState(false);

  useEffect(() => {
    const memberData = localStorage.getItem('member_data');
    if (memberData) {
      const parsedMember = JSON.parse(memberData);
      setMember(parsedMember);
    }
    
    // Simulate loading orders
    setTimeout(() => {
      setLoading(false);
      setOrders([]); // Empty orders for now
    }, 500);
  }, []);

  const handleLogout = async () => {
    setLogoutLoading(true);
    
    try {
      const token = localStorage.getItem('member_token');
      if (token) {
        await axios.post('https://backend.dlapakistan.com/api/members/logout/', {}, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
      }
    } catch (error) {
      console.log('Logout API error:', error);
    }
    
    localStorage.removeItem('member_token');
    localStorage.removeItem('member_data');
    
    if (axios.defaults.headers.common['Authorization']) {
      delete axios.defaults.headers.common['Authorization'];
    }
    
    Swal.fire({
      icon: 'success',
      title: 'Signed Out',
      text: 'You have been signed out successfully.',
      timer: 2000,
      showConfirmButton: false,
    });
    
    navigate('/members/members-area');
    setLogoutLoading(false);
  };

  const handleRemoveOrder = (orderId) => {
    setOrders(orders.filter(order => order.id !== orderId));
  };

  const handleBrowseProducts = () => {
    navigate('/dlashop'); // Change to your products route
  };

  if (!member) {
    return (
      <Container fluid className="py-5 min-vh-100 mt-40" style={{ maxWidth: '95%' }}>
        <div className="text-center py-5">
          <p>Loading...</p>
        </div>
      </Container>
    );
  }

  return (
    <Container fluid className="py-5 min-vh-100 mt-40" style={{ maxWidth: '95%' }}>
      {/* Header with user info and logout - EXACTLY like MembersHome */}
      <div className="mb-6">
        <h1 className="display-6 text-dark mb-3">
          Hello {member.first_name} {member.last_name}
        </h1>
        <p className="text-muted mb-3">
          Manage Account Details!{' '}{' '}{' '}
          <Button 
            variant="link" 
            onClick={handleLogout}
            disabled={logoutLoading}
            className="text-danger p-0"
            style={{ textDecoration: 'none' }}
          >
            {logoutLoading ? 'Signing out...' : 'Log out'}
          </Button>
        </p>
      </div>

      <Row className="g-4">
        {/* Sidebar Column */}
        <Col lg={3} md={4}>
          <MembersSidebar />
        </Col>

        {/* Content Column */}
        <Col lg={9} md={8}>
          <div className="bg-white shadow-sm rounded-lg p-4 p-lg-5">
            <div className="text-left">
              <h4 className="text-[#70B444] mb-4">My Orders</h4>
              
              {loading ? (
                <div className="text-center py-4">
                  <p>Loading orders...</p>
                </div>
              ) : orders.length === 0 ? (
                // Display when no orders exist
                <div className="text-center py-5">
                  <h5 className="text-muted mb-3">No order has been made yet.</h5>
                  <p className="text-muted mb-4">
                    You haven't placed any orders yet. Start shopping to add products to your cart.
                  </p>
                  <Button 
                    variant="success" 
                    onClick={handleBrowseProducts}
                    className="px-4"
                  >
                    Browse Products
                  </Button>
                </div>
              ) : (
                // Display when orders exist
                <>
                  <div className="table-responsive">
                    <Table hover className="mb-0">
                      <thead className="bg-light">
                        <tr>
                          <th className="border-0">Product</th>
                          <th className="border-0 text-center">Quantity</th>
                          <th className="border-0 text-center">Price</th>
                          <th className="border-0 text-center">Total</th>
                          <th className="border-0 text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {orders.map((order) => (
                          <tr key={order.id}>
                            <td className="align-middle">
                              <div className="d-flex align-items-center">
                                {order.image && (
                                  <img 
                                    src={order.image} 
                                    alt={order.name}
                                    className="rounded me-3"
                                    style={{ width: '60px', height: '60px', objectFit: 'cover' }}
                                  />
                                )}
                                <div>
                                  <h6 className="mb-0">{order.name}</h6>
                                  <small className="text-muted">{order.category}</small>
                                </div>
                              </div>
                            </td>
                            <td className="align-middle text-center">{order.quantity}</td>
                            <td className="align-middle text-center">${order.price.toFixed(2)}</td>
                            <td className="align-middle text-center">
                              ${(order.price * order.quantity).toFixed(2)}
                            </td>
                            <td className="align-middle text-center">
                              <Button
                                variant="link"
                                onClick={() => handleRemoveOrder(order.id)}
                                className="text-danger p-0"
                                style={{ textDecoration: 'none' }}
                              >
                                ❌
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  
                  <div className="d-flex justify-content-between align-items-center mt-4 pt-3 border-top">
                    <Button 
                      variant="outline-secondary" 
                      onClick={handleBrowseProducts}
                      className="px-4"
                    >
                      Continue Shopping
                    </Button>
                    <Button 
                      variant="success" 
                      className="px-4"
                      onClick={() => navigate('/checkout')}
                    >
                      Proceed to Checkout
                    </Button>
                  </div>
                </>
              )}
              
              <p className="text-muted mb-0 mt-4">
                Select an option from the sidebar to manage other account settings.
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default MembersOrders;